import { IMarketingCampaign } from './../../models/salesforce/marketing-campaign.model';

import { Observable, of } from 'rxjs';

import { share, map, catchError, switchMap } from 'rxjs/operators';
import { AppState } from './../../interfaces/app-state.interface';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SalesForceAction } from './sales-force.actions';
import { Store } from '@ngrx/store';
import { SentryService } from '../../services/sentry/sentry.service';
import { BackendService } from '../../services/new-http/backend.service';

@Injectable()
export class SalesForceEffects {

  sendMarketingCampaignsData$ = createEffect(() => this.actions$.pipe(
    ofType(SalesForceAction.sendMarketingCampaignsData),
    switchMap((action: { type: string; payload: IMarketingCampaign }) => {
      return this.backendService.salesforceAws
        .post<Record<string, any>>('/campaign', action.payload)
        .pipe(
          map((result) => {
            this.sentryService.sendEvent({
              message: '[UTM|TUUID|GCLID] Effect cookie data',
              extra: { payload: action.payload, result },
              tags: { tuuid: 'true' },
            });

            return {
              type: SalesForceAction.sendMarketingCampaignsDataSuccess,
              payload: action.payload,
            };
          }),
          catchError((e) =>
            of({
              type: SalesForceAction.sendMarketingCampaignsDataError,
              payload: e,
            })
          )
        );
    }),
    share()
  ));

  constructor(
    private actions$: Actions,
    private backendService: BackendService,
    private store: Store<AppState>,
    private sentryService: SentryService
  ) {}
}
